import defaultToEmptyObject from "ramda-extension/es/defaultToEmptyObject";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../constants';
export const getApmConfig = createSelector((state)=>state[REDUCER_NAME], defaultToEmptyObject);
